import React from 'react';

import './style.sass';

import { LoaderWithBlur } from '../LoaderWithBlur';

type Props = {
    isLoading?: boolean,
    className: string,
    children: JSX.Element | JSX.Element[]
};

export const Page = ({ className, children, isLoading }: Props) => {
    return (
        <div className={`page ${className}`}>
            {isLoading && <LoaderWithBlur />}

            { children }
        </div>
    );
};
